import React, { useEffect, useState } from 'react';
import { MapPin } from 'lucide-react';
import { motion } from 'framer-motion';
import { MapContainer, TileLayer, Marker, Popup, Circle } from 'react-leaflet';
import L from 'leaflet';
// Fix for default marker icon in react-leaflet
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
// Custom green icon
const customIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-green.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});
export function ServiceAreaMap() {
  const [isMounted, setIsMounted] = useState(false);
  useEffect(() => {
    setIsMounted(true);
  }, []);
  const cities = [{
    name: 'Mentor',
    coords: [41.6661, -81.3395]
  }, {
    name: 'Willoughby',
    coords: [41.6398, -81.4065]
  }, {
    name: 'Kirtland',
    coords: [41.6028, -81.3362]
  }, {
    name: 'Mayfield Heights',
    coords: [41.5192, -81.4554]
  }, {
    name: 'Chagrin Falls',
    coords: [41.4303, -81.3907]
  }, {
    name: 'Solon',
    coords: [41.3898, -81.4412]
  }, {
    name: 'Twinsburg',
    coords: [41.3128, -81.4401]
  }, {
    name: 'Beachwood',
    coords: [41.4645, -81.5087]
  }, {
    name: 'Shaker Heights',
    coords: [41.4731, -81.5532]
  }, {
    name: 'Moreland Hills',
    coords: [41.4442, -81.4237]
  }];
  const centerCoords: [number, number] = [41.51, -81.42];
  return <section id="service-area" className="py-24 bg-white" data-id="element-268">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-269">
        <div className="text-center mb-12" data-id="element-270">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-271">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#1B4332]/10 text-[#1B4332] mb-6" data-id="element-272">
              <MapPin size={32} data-id="element-273" />
            </div>
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900 mb-4" data-id="element-274">
              Proudly Serving Northeast Ohio
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-275">
              We live and work in these communities. Your neighborhood is our
              neighborhood.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start" data-id="element-276">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="bg-[#FEFAE0] rounded-2xl p-8 border border-[#D4A373]/30" data-id="element-277">
            <h3 className="text-2xl font-serif font-bold text-[#1B4332] mb-6" data-id="element-278">
              Service Areas
            </h3>
            <ul className="space-y-3" data-id="element-279">
              {cities.map((city, idx) => <li key={idx} className="flex items-center gap-3 text-gray-800 font-medium" data-id="element-280">
                  <div className="w-2 h-2 rounded-full bg-[#D4A373]" data-id="element-281"></div>
                  {city.name}
                </li>)}
              <li className="flex items-center gap-3 text-gray-800 font-medium pt-4 border-t border-[#D4A373]/30 mt-4" data-id="element-282">
                <div className="w-2 h-2 rounded-full bg-[#1B4332]" data-id="element-283"></div>
                And surrounding areas
              </li>
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="lg:col-span-2 h-[500px] rounded-2xl overflow-hidden shadow-lg border border-gray-200 z-0 relative" data-id="element-284">
            {isMounted && <MapContainer center={centerCoords} zoom={10} scrollWheelZoom={false} style={{
            height: '100%',
            width: '100%',
            zIndex: 0
          }} data-id="element-285">
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-286" />

                {/* Service Area Circle */}
                <Circle center={centerCoords} radius={25000} pathOptions={{
              color: '#1B4332',
              fillColor: '#1B4332',
              fillOpacity: 0.1
            }} data-id="element-287" />

                {cities.map((city, idx) => <Marker key={idx} position={city.coords as [number, number]} icon={customIcon} data-id="element-288">
                    <Popup data-id="element-289">
                      <strong data-id="element-290">{city.name}</strong>
                      <br data-id="element-291" />
                      Service Area
                    </Popup>
                  </Marker>)}
              </MapContainer>}
          </motion.div>
        </div>
      </div>
    </section>;
}